class TabsHandler {
  constructor() {
    this.mobileBreakpoint = 750;
    this.currentClass = this.getActiveClass();
    this.init();
    this.observeDOM();
    this.setupResizeListener();
  }

  getActiveClass() {
    return window.innerWidth < this.mobileBreakpoint ? 'm-active' : 'active';
  }

  init() {
    document.querySelectorAll('.product-tab:not([data-tab-init])').forEach((tab) => {
      tab.setAttribute('data-tab-init', 'true');
      tab.addEventListener('click', () => {
        this.activateTab(tab);
      });

      const initiallyHidden = tab.getAttribute('data-initiallyhidden') === 'true';
      const observerSelector = tab.getAttribute('data-observer-selector');
      if (initiallyHidden && observerSelector) {
        this.observeTabVisibility(tab, observerSelector);
      }
    });

    document.querySelectorAll('.product-tab-content:not([data-content-init])').forEach((content) => {
      content.setAttribute('data-content-init', 'true');
      content.addEventListener('click', (e) => {
        if (!e.target.closest('.product-tab-content__inner')) {
          this.closeMobileTabs();
        }
      });
    });

    document.querySelectorAll('.product-tab-content .close-button:not([data-close-init])').forEach((btn) => {
      btn.setAttribute('data-close-init', 'true');
      btn.addEventListener('click', () => {
        this.closeMobileTabs();
      });
    });
  }

  observeTabVisibility(tabElement, selector) {
    const target = document.querySelector(selector);

    if (target && target.children.length > 0) {
      tabElement.classList.add('display');
      return;
    }

    const observer = new MutationObserver(() => {
      const observedTarget = document.querySelector(selector);
      if (observedTarget && observedTarget.children.length > 0) {
        tabElement.classList.add('display');
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  activateTab(tabElement) {
    const container = tabElement.closest('.product-tabs__container');
    if (!container) return;

    const isMobile = this.currentClass === 'm-active';

    const targetId = tabElement.getAttribute('data-targetid');
    if (!targetId) return;

    const targetContent = container.querySelector(`#${targetId}`);
    if (!targetContent) return;

    container.querySelectorAll('.product-tab').forEach((tab) => {
      tab.classList.remove('active');
    });
    container.querySelectorAll('.product-tab-content').forEach((content) => {
      content.classList.remove('active');
    });

    tabElement.classList.add('active');
    targetContent.classList.add('active');

    if (isMobile) {
      container.querySelectorAll('.product-tab').forEach((tab) => {
        tab.classList.remove('m-active');
      });
      container.querySelectorAll('.product-tab-content').forEach((content) => {
        content.classList.remove('m-active');
      });

      tabElement.classList.add('m-active');
      targetContent.classList.add('m-active');

      document.body.classList.add('modal-opened');
      document.documentElement.classList.add('modal-opened');
    }
  }

  closeMobileTabs() {
    document.querySelectorAll('.product-tab, .product-tab-content').forEach((el) => {
      el.classList.remove('m-active');
    });

    document.body.classList.remove('modal-opened');
    document.documentElement.classList.remove('modal-opened');
  }

  observeDOM() {
    const observer = new MutationObserver(() => {
      this.init();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  setupResizeListener() {
    window.addEventListener('resize', () => {
      const newClass = this.getActiveClass();

      if (newClass !== this.currentClass) {
        if (this.currentClass === 'm-active' && newClass === 'active') {
          this.removeAllMobileActive();
        }

        this.currentClass = newClass;
      }
    });
  }

  removeAllMobileActive() {
    document.querySelectorAll('.product-tab, .product-tab-content').forEach((el) => {
      el.classList.remove('m-active');
    });

    document.body.classList.remove('modal-opened');
    document.documentElement.classList.remove('modal-opened');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.tabsHandler = new TabsHandler();
});
